import {defineStore} from "pinia";
import {ref} from "vue";

const useLayout = defineStore('layout', () => {
    const title = ref("")
    // [{label, to?}] — when set, the header renders these instead of the plain title
    const breadcrumbs = ref([])
    const setTitle = (t) => {
        title.value = t
        breadcrumbs.value = []
    }
    const setBreadcrumbs = (items) => {
        breadcrumbs.value = items
        title.value = items.length ? items[items.length - 1].label : ''
    }
    return {title, breadcrumbs, setTitle, setBreadcrumbs}
})


export default useLayout